import { HttpClient } from "../api/network";

export interface WizardDoc {
  id: string;
  wizardID: string;
  customerID?: string;
  productionArtwork?: ProductionArtworkType[];
  wizardData: {
    disableWidth?: boolean;
    disableHeight?: boolean;
    artWidth?: string;
    artHeight?: string;
    [key: string]: any;
  };
}

export interface ProductionArtworkType {
  DTFProcessed?: boolean;
  DTFProcessedFileId?: string;
  userFileConfig?: string;
  date?: string;
  fileRole?: string;
  [key: string]: any;
}

export interface ProcessUCMaxRequest {
  orderNumber: string;
  docIds: string[];
}

export interface ProcessUCMaxResponse {
  processed: WizardDoc[];
  errors: number[];
}

export interface BatchUCMaxRequest {
  docs: Array<{
    id: string;
    quantity: number;
  }>;
  orderNo: string;
}

export interface ProcessingResult {
  wizardDoc: WizardDoc;
  status: number;
  error: string | null;
}

export class DTFProcessClient {
  private httpClient: HttpClient;

  constructor(baseUrl: string) {
    this.httpClient = new HttpClient(baseUrl);
  }

  async processUCMax(request: ProcessUCMaxRequest): Promise<ProcessUCMaxResponse> {
    return await this.httpClient.post<ProcessUCMaxRequest, ProcessUCMaxResponse>({
      resource: '/ProcessUCMax',
      payload: request,
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  async batchUCMax(
    request: BatchUCMaxRequest,
    onProgress?: (progress: number) => void
  ): Promise<Blob> {
    const blob = await this.httpClient.postBlob<BatchUCMaxRequest>(
      {
        resource: '/BatchUCMax',
        payload: request,
        headers: {
          'Content-Type': 'application/json',
        }
      },
      onProgress
    );

    if (!blob || !(blob instanceof Blob)) {
      throw new Error('Invalid blob response received');
    }

    console.log('Blob received:', {
      size: blob.size,
      type: blob.type,
      isBlob: blob instanceof Blob
    });

    return blob;
  }

  async dtfProcessNoWhiteBacking(
    docId: string,
    onProgress?: (progress: number) => void
  ): Promise<Blob> {
    const blob = await this.httpClient.getBlob(
      {
        resource: 'DownloadPdfFromCadx/' + docId,
        headers: {
          'Content-Type': 'application/json',
        }
      },
      onProgress
    );

    if (!blob || !(blob instanceof Blob)) {
      throw new Error('Invalid blob response received');
    }

    console.log('Blob received:', {
      size: blob.size,
      type: blob.type,
      isBlob: blob instanceof Blob
    });

    return blob;
  }

  downloadBlobAsFile(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}

export default DTFProcessClient;